<template>
  <div class="language-selection" ref="languageWrapper">
    <input
      id="toggleLabel"
      type="checkbox"
      class="language-selection__checkbox"
      v-model="flyoutActive"
    />
    <label for="toggleLabel" class="language-selection__cta">{{ cta }}</label>
    <ul class="language-selection__flyout" v-if="flyoutActive">
      <li
        :class="['language-selection__item', `language-selection__item--${lang.code}`]"
        v-for="lang in languages"
        :key="lang.code"
        @click="updateLanguageActions(lang.code)"
      >{{lang.code.toUpperCase()}}</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { vuexGetters, vuexMutations } from "../store";
export default {
  name: "LanguageSelection",
  data() {
    return {
      flyoutActive: false
    };
  },
  mounted() {
    this.$refs.languageWrapper.addEventListener("mouseenter", () => {
      this.flyoutActive = true;
    });
    this.$refs.languageWrapper.addEventListener("mouseleave", () => {
      this.flyoutActive = false;
    });
  },
  computed: {
    ...mapGetters({
      languages: vuexGetters.LANGUAGES
    }),
    cta() {
      const languages = this.languages.map(lang => lang.code.toUpperCase());
      return languages.join("/");
    }
  },
  methods: {
    ...mapMutations({
      updateLanguage: vuexMutations.UPDATE_LANG
    }),
    updateLanguageActions(lang) {
      this.updateLanguage(lang);
      this.flyoutActive = false;
      window.location.href = `/${lang}/`;
    }
  }
};
</script>

<style lang="scss" scoped>
.language-selection {
  cursor: pointer;
  font-size: 0.8125rem;
  line-height: 1.2em;
  color: $eminence;
  margin-right: 5px;
  position: relative;

  &__flyout {
    font-size: 0.8125rem;
    background-color: $white;
    position: absolute;
    right: 0;
    left: 0;
    text-align: center;
    padding: 10px 0;
  }

  &__item {
    display: block;
    line-height: 3em;

    &:hover {
      color: $white;
      background-color: $east-side;
    }
  }

  &__checkbox {
    position: absolute;
    left: -9999.99rem;
  }
}
</style>